<aside class="aside-container">
  <!-- CROSS-SELL -->
  <!-- Overlay -->
  @let suggestedProductsExists = !!(carouselBuyAgainProducts().length || carouselFavoritesProducts().length ||
  carouselSuggestedProducts().length);

  @let showMobileCartOverlay = isMobile() && !hideCrossSells() && suggestedProductsExists;
  @if (showMobileCartOverlay) {
  <div class="aside-container__overlay" (click)="toggleCrollSells(true)"></div>
  }

  <!-- Cross Sells -->
  <section class="cross-sells orders-scroll" [class.cross-sells--global-message]="hasGlobalMessage()"
    [class.cross-sells--hide]="hideCrossSells() && suggestedProductsExists"
    [class.cross-sells--open]="suggestedProductsExists">

    @if (hideCrossSells()) {

    <section class="cross-sells__toggle-container" (click)="toggleCrollSells(false)">
      <span class="material-symbols-outlined close pulse">
        {{isMobile() ? 'arrow_forward' : 'arrow_back'}}
      </span>

      <span class="cross-sells__view-products">
        <!-- {{ isMobile() ? 'Personalized Picks Waiting' : 'View Suggestions'}} -->
        Find Your Favorites
      </span>

      <span class="quanity-badge pulse-rotate">
        {{suggestedTotals()}}
      </span>

    </section>

    } @else {

    <header class="position-relative d-flex gap-2 justify-content-center align-items-center">

      <h4 class="cross-sells__title">
        Recommendations
      </h4>

      <span class="material-symbols-outlined close" (click)="toggleCrollSells(true)">
        close
      </span>

    </header>

    <section class="cross-sells__content">

      @let suggestedProducts = carouselSuggestedProducts();
      @let suggestedProductsLength = suggestedProducts?.length;

      @if (suggestedProductsLength) {
      <div class="d-flex justify-content-between mt-2">
        <span class="title">
          Other People Also Added
        </span>
        @if (suggestedProductsLength > 3) {
        <a href="javascript:void(0)" class="h8-bold link-color"
          (click)="viewAll(suggestedProducts, suggestedProductsType.marketplace)">
          View All
        </a>
        }
      </div>

      @let suggestedResume = suggestedProducts.slice(0, 3);
      <!-- @let suggestedResume = suggestedProducts; -->
      @for (product of suggestedResume; track product.productDetails.id) {
      <div>
        <app-product-card-v2 [cardResume]="product"></app-product-card-v2>
      </div>
      }
      }

      @let favoriteProducts = carouselFavoritesProducts();
      @let favoritesLength = favoriteProducts?.length;

      @if (favoritesLength) {
      <div class="d-flex justify-content-between mt-2">
        <span class="title">
          Favorites
        </span>
        @if (favoritesLength > 3) {
        <a href="javascript:void(0)" class="h8-bold link-color"
          (click)="viewAll(favoriteProducts, suggestedProductsType.favorite)">
          View All
        </a>
        }
      </div>


      @let favoritesResume = favoriteProducts.slice(0, 3);
      <!-- @let favoritesResume = favoriteProducts; -->
      @for (product of favoritesResume; track product.productDetails.id) {
      <div>
        <app-product-card-v2 [cardResume]="product"></app-product-card-v2>
      </div>
      }
      }

      @let buyAgainProducts = carouselBuyAgainProducts();
      @let buyAgainLength = buyAgainProducts?.length;

      @if (buyAgainLength) {
      <div class="d-flex justify-content-between mt-2">
        <span class="title">
          Buy Again
        </span>
        @if (buyAgainLength > 3) {
        <a href="javascript:void(0)" class="h8-bold link-color"
          (click)="viewAll(buyAgainProducts, suggestedProductsType.buyAgain)">
          View All
        </a>
        }
      </div>

      @let buyAgainResume = buyAgainProducts.slice(0, 3);
      <!-- @let buyAgainResume = buyAgainProducts; -->
      @for (product of buyAgainResume; track product.productDetails.id) {
      <div>
        <app-product-card-v2 [cardResume]="product"></app-product-card-v2>
      </div>
      }
      }

    </section>
    }

  </section>

  <!-- ORDER -->
  <section class="cart-preview-page-container" [class.w-100]="isMobile()" [class.cart-blur]="showMobileCartOverlay">
    <!-- Inside the cart column, not a direct child of the aside: that aside is a
         flex row, so the banner turned into a column of its own and squeezed
         itself into a sliver beside the cart (DEV-10988). -->
    <app-past-due-banner />

    <header class="d-flex flex-column gap-2 cart-preview-header animated fadeInRight">

      <h5 class="d-flex align-items-center justify-content-between pt-2" role="button"
        (click)="isDeliveryDetailsCollapsed.set(!isDeliveryDetailsCollapsed())"
        [attr.aria-expanded]="!isDeliveryDetailsCollapsed()" [attr.aria-controls]="'yourDeliveryInfo'">
        @if (!isMobile()) {
        <i class="fas fa-times" (click)="closeSideCart()"></i>
        }

        @if (isSkipped()) {
        You've Skipped Your Order!
        } @else {
        <section class="d-flex flex-column gap-0" [class.align-items-center]="!this.isMobile()"
          [class.align-items-start]="this.isMobile()">
          <span class="h7-bold">{{deliveryDetailsText()}}</span>
          <section class="d-flex gap-4">
            <section class="d-flex gap-1 align-items-baseline h8-semibold">
              <i class="text-black fas fa-truck"></i>
              <span class="fw-semibold"><i>{{deliveryInfo()?.mobileDeliveryDateText}}</i></span>
            </section>
            <section class="d-flex gap-1 align-items-baseline h8-semibold">
              <i class="text-black fas fa-clock"></i>
              <span class="fw-semibold"><i>Edit Before {{deliveryInfo()?.mobileCoutoffText}}</i></span>
            </section>
          </section>
        </section>
        }
        <i class="fas" [ngClass]="{
                'fa-chevron-down': isDeliveryDetailsCollapsed(),
                'fa-chevron-up': !isDeliveryDetailsCollapsed()
              }"></i>
      </h5>

      @if(isSkipped()) {
      <p class="text-center">You will not be receiving your order this week.</p>
      } @else {
      @if (isTemporaryRouteChange()) {
      <app-empty-message [message]="temporaryRouteChangeMessage()"></app-empty-message>
      }

      @if(!marketStatus().isOpen) {
      <section class="card-delivery-date animated fadeIn">
        <section class="d-flex gap-3">
          <div class="d-flex flex-column">
            <h5 class="h7-bold fw-bold m-0 text-secondary-800 text-center">
              {{closedMarket().title}}
            </h5>
            <span class="h8-semibold text-start text-black text-center">
              {{closedMarket().legend}}
            </span>
          </div>
        </section>
      </section>
      }
      }

      <section id="yourDeliveryInfo"
        [classList]="isDeliveryDetailsCollapsed() ? 'collapse' : 'collapse show animated fadeIn d-flex flex-column gap-2'"
        [attr.aria-hidden]="isDeliveryDetailsCollapsed()">

        <!-- Delivery date -->
        @if (deliveryInfo()) {
        <section class="card-delivery-date animated fadeIn">
          <section class="d-flex gap-3">
            <div class="d-flex justify-content-center align-items-center">
              <i class="material-symbols-outlined text-secondary-800">calendar_today</i>
            </div>
            <div class="d-flex flex-column">
              <h5 class="h8-bold fw-bold m-0 text-secondary-800">
                {{deliveryInfo()?.deliveryDateText}}
              </h5>
              <p class="order-info__item-text h8-regular">
                {{ deliveryInfo()?.deliveryWindow }}
              </p>
              <span class="h8-semibold text-start text-black">
                Edit before {{deliveryInfo()?.cutoffDateText}}
              </span>
            </div>
          </section>
        </section>
        }

        <!-- Pickup/Delivery Address -->
        @if (addressInfo()) {
        <section class="card-primary animated fadeIn">
          <section class="d-flex gap-3 align-items-center">
            <div class="d-flex justify-content-center align-items-center">
              <i class="material-symbols-outlined text-secondary-800">location_on</i>
            </div>
            <div class="d-flex flex-column">
              <span class="h8-semibold text-start text-black">
                {{ addressInfo()?.text }}
              </span>
            </div>
          </section>
          @if (permissionsSetup().hasDeliveriesPermission) {
          <section class="d-flex">
            <a class="badge link-color" role="button" (click)="openDeliveriesModal()">
              <i class="material-symbols-outlined text-secondary-800">edit</i>
            </a>
          </section>
          }
        </section>
        }

        <!-- Payment Method -->
        @if (paymentMethodInfo()) {
        <section class="card-primary animated fadeIn">
          <section class="d-flex gap-3 align-items-center">
            <div class="d-flex justify-content-center align-items-center">
              <i class="material-symbols-outlined text-secondary-800">credit_card</i>
            </div>
            <div class="d-flex flex-column">
              <span class="h8-semibold text-start text-black">
                **** **** **** {{ paymentMethodInfo() }}
              </span>
            </div>
          </section>
          @if (permissionsSetup().hasPaymentMethodPermission) {
          <section class="d-flex">
            <a class="badge link-color" role="button" (click)="openPaymentMethodModal()">
              <i class="material-symbols-outlined text-secondary-800">edit</i>
            </a>
          </section>
          }
        </section>
        }
      </section>

      @if (orderOnWay()?.id) {
      <section class="order-on-way">
        @if (orderOnWay()?.isOnWay) {
        <p class="main-info">Your <b class="text-primary">{{orderOnWay()?.deliveryDate}}</b> order is on the way!</p>
        } @else {
        <p class="main-info">We're preparing your order for <b class="text-primary">{{orderOnWay()?.deliveryDate}}</b>.
        </p>
        }
        <a href="javascript:void(0)" [routerLink]="['/settings/billing/order-and-billing/'+orderOnWay()?.id]"
          class="h8-semibold link-color m-0">
          View
        </a>
      </section>
      }

      <!-- Order Minimum & Free Delivery -->
      @if (showFreeDeliverySlider() && !isSkipped() && !isEmptyOrder()) {
      <app-order-slider [hasMinOrder]="hasMinOrder()" [minOrder]="minOrder()"
        [minOrderDiffForFreeDelivery]="minOrderDiffForFreeDelivery()" [percentMinSpend]="percentMinSpend()"
        [orderDeliveryFee]="orderDeliveryFee()" [enableFreeDeliveryThreshold]="enableFreeDeliveryThreshold()"
        [hasDeliveryFeeRange]="hasDeliveryFeeRange()" [currentSliderInfo]="currentSliderInfo()"
        [validationMethod]="minimumSpendValidationMethod()" [hasPricelistDiscount]="hasPricelistDiscount()"
        [qualifyingSubtotal]="qualifyingSubtotal()"></app-order-slider>
      }

    </header>

    <section class="cart-preview-body animated fadeInRight" [class.padding-bottom-mobile]="isMobile()"
      [class.justify-content-center]="isEmptyOrder()" [class.justify-content-between]="!isEmptyOrder()">

      @if (isSkipped() && odooOrder()?.invoiceDetails?.donation?.amount) {
      <!-- Skipped Order -->
      <div class="layout-order__sidebar p-4 animated fadeInRight" [ngClass]="{'d-none': !isMobile()}">
        <div class="card border-0 mt-4 animated fadeInRight">
          <div class="row justify-content-between">
            <div class="col text-center">
              <h5>Thank you for your donation!</h5>
              <p>
                You've donated
                <b>{{ (odooOrder()?.invoiceDetails?.donation?.amount) | currency }}</b>
                to help us feed our local community.
                <a routerLink="/pages/about-us/donations" target="_blank" class="fw-bold">Learn more</a>
                about our donation program.
              </p>
            </div>
          </div>
        </div>
      </div>
      }

      <!-- Empty cart -->
      @if (isEmptyOrder() && !isSkipped() && !skippedSubscriptions()?.length) {

      <div class="d-flex flex-column align-items-center mt-5 animated fadeInRight">

        <img src="/assets/images/logo-main.svg" alt="Carlton Farms Logo" class="w-40">

        <span class="h3-semibold text-center text-primary mt-3">
          Your cart is empty!
        </span>

        <span class="h5-semibold text-center text-primary mt-2 w-75">
          Start shopping now to fill it with amazing items.
        </span>

        <button type="button" class="btn btn-outline-primary mt-3" (click)="goToMarket()">
          Start Shopping
        </button>

      </div>
      } @else {
      <!-- Product -->
      <section class="order-products">

        <!-- Skipped products -->
        @if (skippedSubscriptions()?.length && !isSkipped()) {

        <div class="d-flex justify-content-between">

          <h6 class="d-flex align-items-center justify-content-between pt-2 gap-2 w-100 text-center" role="button"
            (click)="areSkippedProductsCollapsed.set(!areSkippedProductsCollapsed())"
            [attr.aria-expanded]="!areSkippedProductsCollapsed()"
            [attr.aria-controls]="'skippedSubscriptionsContainer'">
            Skipped Products
            <i class="fas" [ngClass]="{
            'fa-chevron-down': areSkippedProductsCollapsed(),
            'fa-chevron-up': !areSkippedProductsCollapsed()
          }"></i>
          </h6>
        </div>

        <section class="skipped-container" id="skippedSubscriptionsContainer"
          [classList]="areSkippedProductsCollapsed() ? 'collapse' : 'collapse show animated fadeIn d-flex flex-column gap-2'">

          <div class="alert bg-transparent d-flex align-items-center animated fadeIn p-0 m-0" role="alert">
            <div class="h7-regular text-black-50">
              You skipped these products for this delivery. {{isMobile() ? 'Tap' : 'Click'}}
              <b><i>'Unskip'</i></b> to add them back!
            </div>
          </div>

          @for (product of skippedSubscriptions(); track product.id) {
          <app-product-cart-preview [deliveryInfo]="deliveryInfo()" [allowModification]="false" [product]="product"
            [isSkipped]="true" [isSubscription]="true" [isInOrder]="true" productKey="subscription"
            class="my-3"></app-product-cart-preview>
          }

        </section>

        <hr class="mb-2 border-hr">

        }

        <!-- Subscriptions -->
        @if (odooOrderProducts()?.subscription.length) {

        <div class="d-flex justify-content-between" [class.mt-3]="!skippedSubscriptions()?.length">
          <span class="h7-semibold text-black-50">
            Subscriptions
          </span>
          @if (permissionsSetup().hasSubscripcionPermission) {
          <a [routerLink]="['/settings/account/subscriptions']" class="h8-bold link-color">
            Manage subscriptions
          </a>
          }
        </div>

        <section class="subscriptions-continaer">

          @if (isSkipped()) {
          <div class="subscriptions-overlay text-center d-flex gap-3 flex-column"></div>
          }

          <!-- Odoo "subscription" products -->
          @for (product of odooOrderProducts()?.subscription; track $index) {
          <app-product-cart-preview [deliveryInfo]="deliveryInfo()" [product]="product" [isInOrder]="true"
            [isSubscription]="true" productKey="subscription" class="my-3"></app-product-cart-preview>
          }

        </section>
        }

        <!-- A la carte -->
        @if (odooOrderProducts()?.common.length) {

        <hr class="mt-3 border-hr">

        <span class="h7-semibold text-black-50">
          A la carte
        </span>

        <!-- Odoo "a la carte" products -->
        @for (product of odooOrderProducts()?.common; track $index) {
        <app-product-cart-preview [deliveryInfo]="deliveryInfo()" [product]="product" [isInOrder]="true"
          [allowModification]="true" [isPreorder]="product.isPreOrder" [isSubscription]="false"
          productKey="common" class="my-3"></app-product-cart-preview>
        }
        }
      </section>

      <!-- Details -->
      @if (!isSkipped()) {

      <hr class="m-0">

      <section class="order-details">

        <!-- Promotions -->
        <app-promotion-tags [coupons]="odooOrder()?.paymentDetails?.coupons ?? []"
          [hasAutoApplicableCoupon]="hasAutoApplicableCoupon()" [fromCartPreview]="true"
          [hasPendingChanges]="hasPendingChanges()"></app-promotion-tags>

        <!-- Subtotal -->
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">
            Subtotal
          </span>
          <span class="h7-bold text-black font-variant-nums">
            {{orderGrossSubTotal().toFixed(2) | currency}}
          </span>
        </div>

        <!-- Additional Fees -->
        @for (fee of additionalFees(); track $index) {
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">
            {{fee.name}}
          </span>
          <span class="h7-bold text-secondary-700 font-variant-nums">
            {{fee.total | currency}}
          </span>
        </div>
        }

        <!-- Taxes -->
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">
            Taxes
          </span>
          <span class="h7-bold text-black font-variant-nums">
            {{orderTaxes().toFixed(2) | currency}}
          </span>
        </div>

        <!-- Delivery -->
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">
            Delivery
          </span>
          @if (orderDeliveryFee()) {
          <span class="h7-bold text-black font-variant-nums">
            {{orderDeliveryFee().toFixed(2) | currency}}
          </span>
          } @else {
          <span class="h7-bold text-black">FREE</span>
          }
        </div>

        <!-- Tip -->
        @if (hasDriverTipsFlow()) {
        <div class="d-flex justify-content-between">

          <span class="h7-bold text-black-50">
            Tip
            @if (odooOrder()?.paymentDetails?.tip?.isRecurrent) {
            <i class="fa fa-refresh text-black-50" aria-hidden="true"></i>
            }
          </span>

          <div class="d-flex {{isMobile() ? 'gap-5': 'gap-4'}}">

            @if (!orderTipAmount()) {
            <a href="javascript:void(0)" (click)="openModalTip(createTip)" class="h7-semibold link-color">
              Add
            </a>
            } @else {
            <a href="javascript:void(0)" (click)="openModalTip(updateTip)" class="h7-semibold link-color">
              Edit
            </a>

            <a href="javascript:void(0)" (click)="deleteTip()" class="h7-semibold link-color">
              Delete
            </a>
            }

            <span class="h7-bold text-black font-variant-nums">
              {{orderTipAmount().toFixed(2) | currency}}
            </span>

          </div>

        </div>
        }

        <!-- Donation -->
        @if (hasVoluntaryDonationFlow() && orderDonationAmountVoluntary()) {
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">
            Donation
            @if (odooOrder()?.paymentDetails?.donation?.isRecurrent) {
            <i class="fa fa-refresh text-black-50" aria-hidden="true"></i>
            }
          </span>

          <div class="d-flex {{isMobile() ? 'gap-5': 'gap-4'}}">
            <a href="javascript:void(0)" (click)="openModalDonation(updateDonation)" class="h7-semibold link-color">
              Edit
            </a>

            <a href="javascript:void(0)" (click)="deleteDonationVoluntary()" class="h7-semibold link-color">
              Delete
            </a>

            <span class="h7-bold text-black font-variant-nums">
              {{orderDonationAmountVoluntary().toFixed(2) | currency}}
            </span>

          </div>

        </div>
        }

        <!-- Credits -->
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">
            Credits
          </span>
          <span class="h7-bold font-variant-nums"
            [class.text-success]="orderCredits() > 0" [class.text-black]="!(orderCredits() > 0)">
            {{orderCredits().toFixed(2) | currency}}
          </span>
        </div>

        <!-- Credits -->
        @if (orderCredits()) {
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">Applied credits</span>
          <span class="h7-bold font-variant-nums"
            [class.text-success]="appliedCredits() > 0" [class.text-black]="!(appliedCredits() > 0)">{{ (appliedCredits()) | currency }}</span>
        </div>

        <!-- Credits -->
        <div class="d-flex justify-content-between">
          <div class="h7-bold text-black-50">Credit balance</div>
          <span class="h7-bold font-variant-nums"
            [class.text-success]="creditsBalance() > 0" [class.text-black]="!(creditsBalance() > 0)">{{ (creditsBalance()) | currency }}</span>
        </div>

        }

        <!-- Seasonal Deposits -->
        @if (odooOrder()?.paymentDetails?.seasonalDeposits) {
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">Seasonal Deposits</span>
          <span class="h7-bold text-black font-variant-nums">
            {{ odooOrder()?.paymentDetails?.seasonalDeposits | currency }}
          </span>
        </div>
        }

        <!-- Deposits -->
        @if (odooOrder()?.paymentDetails?.deposits) {
        <div class="d-flex justify-content-between">
          <span class="h7-bold text-black-50">Deposits</span>
          <span class="h7-bold text-black font-variant-nums">
            {{ odooOrder()?.paymentDetails?.deposits | currency }}
          </span>
        </div>
        }

        <!-- DEV-11172: pre-order deposit already collected on the deposit
             invoice, rendered as a separate summary row (green, like a
             positive credit toward the order) so the customer sees it as
             "money already paid" — not a product line, and not a
             "saving". Tooltip explains this to anyone who does not
             remember paying the deposit. -->
        @if (odooOrder()?.paymentDetails?.preOrderDepositPaid) {
        <div class="d-flex justify-content-between text-success">
          <span class="h7-bold d-flex align-items-center gap-1">
            Pre-order deposit paid
            <i class="material-symbols-outlined cursor-pointer"
              style="font-size: 1rem;"
              [triggers]="isMobile() ? 'click' : 'hover focus'"
              [autoClose]="true"
              tabindex="0"
              role="button"
              ngbTooltip="You already paid this deposit when you placed your pre-order. It's now being applied to your final order total, reducing the amount owed."
              container="body">info</i>
          </span>
          <span class="h7-bold font-variant-nums">
            {{ (-odooOrder()!.paymentDetails!.preOrderDepositPaid) | currency }}
          </span>
        </div>
        }

        <!-- Saving -->
        @if (totalSavings()) {
        <div class="d-flex justify-content-between text-success">
          <section class="d-flex gap-1 justify-content-center align-items-center">
            <span class="h7-bold">
              Total Savings!
            </span>
            <!-- DEV-11173: the `h5` class was pulling in the brand heading
                 font-family, so the icon rendered as the literal word
                 "info" instead of a Material Symbols glyph. Switched to
                 <i> with an inline font-size. -->
            <i class="material-symbols-outlined cursor-pointer"
              style="font-size: 1rem;"
              [triggers]="isMobile() ? 'click' : 'hover focus'"
              [autoClose]="true"
              tabindex="0"
              role="button"
              ngbTooltip="This is what you're saving on your order thanks to discounts, promotions, and coupons!"
              container="body">info</i>
          </section>
          <span class="h7-bold text-success font-variant-nums">
            {{(-totalSavings()).toFixed(2) | currency}}
          </span>
        </div>
        }

        <!-- Membership savings + upgrade (DEV-10551) -->
        @if (hasMembershipFlow() && (membershipSavingsOnOrder() || membershipUpgradePreview())) {
        <div class="py-2">
          <app-membership-savings variant="panel" [savings]="membershipSavingsOnOrder()"
            [membershipName]="membershipInfo()?.membershipName" [breakdown]="membershipSavingsBreakdown()"
            [upgrade]="membershipUpgradePreview()" [isMember]="hasMembership()" (upgradeClick)="upgradeMembership()">
          </app-membership-savings>
        </div>
        }

        <!-- Total -->
        <hr class="m-0">
        <div class="d-flex justify-content-between">
          <span class="h6-bold text-black">
            Total
          </span>
          <span class="h6-bold text-black font-variant-nums">
            {{orderTotal().toFixed(2) | currency}}
          </span>
        </div>

        <section>
          @if (odooOrder()?.id || (products()?.common?.length || products()?.subscription?.length)) {
          <div class="coupon-action">
            <div class="coupon-input">
              <div class="form">
                <input type="text" [(ngModel)]="coupon" placeholder="Enter coupon or gift certificate code"
                  class="form-control" id="couponCode">
              </div>
            </div>
            <div>
              <button [disabled]="isUpdating()" (click)="applyCoupon()"
                class="btn btn-sm btn-outline-primary">Apply</button>
            </div>
          </div>

          @if(showCouponErrorMessage()){
          <div class="order-action-alert alert alert-warning animated fadeIn mt-3 mb-2">
            <span class="alert-icon material-symbols-outlined">error</span>
            <div class="w-100">
              <p class="fw-semibold mb-0">This coupon couldn't be applied.</p>
              <span>{{couponErrorMessage()}}</span>
            </div>
          </div>
          }
          }

          @if (!orderDonationAmountVoluntary() && hasVoluntaryDonationFlow()) {
          <div class="donation-action animated fadeInUp mt-4">
            <button class="w-100 btn btn-sm btn-outline-primary fs-6" (click)="openModalDonation(createDonation)">Make a
              Donation
            </button>
          </div>
          }

        </section>

        <section class="skip-order">
          <!-- Skip deliveries -->
          @if (hasPreorderedProducts()) {
          <section class="pt-4">
            <!-- DEV-11183: short line + tooltip instead of the full-width warning,
                 so the cart keeps the same shape with or without pre-orders. -->
            <p class="d-flex align-items-center justify-content-center gap-1 m-0 pt-3 h7-regular animated fadeIn">
              This order cannot be skipped
              <i class="material-symbols-outlined cursor-pointer" style="font-size: 1rem;"
                [triggers]="isMobile() ? 'click' : 'hover focus'"
                [autoClose]="true"
                tabindex="0"
                role="button"
                [ngbTooltip]="preOrdersSkipDisclaimer()"
                container="body">info</i>
            </p>
          </section>
          } @else {
          @if (!isSkipped() && odooOrder()?.id &&
          (odooOrderProducts()?.common.length || odooOrderProducts()?.subscription.length)) {
          <section class="d-flex justify-content-center">
            <div class="animated fadeIn">
              <a (click)="onChangeSkipWeekDelivery()" class="h7-bold link-color w-100 text-center mb-4">
                Skip This Week's Order
              </a>
            </div>
          </section>
          }
          }
        </section>

      </section>


      }

      }


    </section>

    <footer class="d-flex flex-column gap-1 animated fadeInRight mt-auto cart-preview-footer pt-3">

      @if ((odooOrderProducts()?.subscription.length || odooOrderProducts()?.common.length) && !isSkipped()) {
      <app-empty-message [marginBottom2]="true" [shouldShowSmallText]="true" [displayIcon]="false"
        [message]="noCheckoutNeeded()" [isHtml]="true"></app-empty-message>
      }

      @if(isSkipped()) {
      <!-- Unskip Ordeer -->
      <button type="button" class="btn btn-primary btn-sm d-block w-100 animated fadeInDown h6-semibold mb-4 "
        (click)="onChangeSkipWeekDelivery(true)">
        Unskip Order
      </button>
      }

    </footer>
  </section>

</aside>